import { useClerk } from "@clerk/tanstack-react-start";
import { createFileRoute } from "@tanstack/react-router";
import { LogOut } from "lucide-react";

import { Button } from "@/components/ui/button";
import { SectionCard } from "@/components/ui/section-card";
import { invalidateClientClerkAuthCache } from "@/routes/__root";

export const Route = createFileRoute("/_authenticated/app/settings/account")({
  component: AccountSettings,
});

function AccountSettings() {
  const { signOut } = useClerk();

  return (
    <SectionCard title="Account" description="Manage your account">
      <Button
        variant="outline"
        onClick={() => {
          invalidateClientClerkAuthCache();
          signOut({ redirectUrl: "/sign-in" });
        }}
        className="text-destructive hover:bg-destructive hover:text-destructive-foreground"
      >
        <LogOut className="mr-2 h-4 w-4" />
        Sign out
      </Button>
    </SectionCard>
  );
}
